package org.braunequip.web.util

import kotlinx.datetime.internal.JSJoda.Clock
import kotlinx.datetime.internal.JSJoda.LocalDate
import kotlin.experimental.and

// PAGE IS ROUGH DUPLICATE OF FRONTEND VERSION

/*
    REFER TO MainItemsDTO for status!

    Using when to apply one status, but will be compatible with multiple statuses if needed later.
 */
fun parseMaintItemStatus(value: Short): List<String> {
    //Old version of it
//    if (value == MaintItemStatus.DELETED.status) statuses.add("Deleted")
//    if ((value and MaintItemStatus.PENDING.status) != 0.toShort()) statuses.add("Pending")
//    if ((value and MaintItemStatus.COMPLETED.status) != 0.toShort()) statuses.add("Completed")
//    if ((value and MaintItemStatus.OVERDUE.status) != 0.toShort()) statuses.add("Overdue")

    return when (value) {
        MaintItemStatus.DELETED.status -> listOf("Deleted")
        MaintItemStatus.PENDING.status -> listOf("Pending")
        MaintItemStatus.COMPLETED.status -> listOf("Completed")
        MaintItemStatus.OVERDUE.status -> listOf("Overdue")
        else -> emptyList()
    }
}


fun hasFlag(status: Short, flag: Short): Boolean {
    return status and flag != 0.toShort()
}